import script from "./Text.vue?vue&type=script&setup=true&lang=ts"
export * from "./Text.vue?vue&type=script&setup=true&lang=ts"

import "./Text.vue?vue&type=style&index=0&id=1edafc36&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1edafc36"]])

export default __exports__